module.exports = __webpack_public_path__ + "assets/img/stateful_funtional.cadbda76.jpg";